import { Injectable, signal } from '@angular/core';
import { Tag } from "../../entities/tag/tag";
import { Apollo } from 'apollo-angular';
import { TimeTrack } from 'src/app/entities/time-track/time-track';
import { ActionsService } from '../actions-service/actions.service';
import { DateService } from '../date-service/date.service';

@Injectable({
  providedIn: 'root'
})
export class BasicDataService {
  //projects = signal<Project[]>([]);

  tags = signal<Tag[]>([]);

  tracks = signal<TimeTrack[]>([]);

  constructor(
    private apollo: Apollo,
    protected actionsService: ActionsService,
    protected dateService: DateService
  ) { }



  protected fetchTags() {
    return [
      new Tag('frontend', '36736873-adeb-4034-9df8-bb222e4a3c1e'),
      new Tag('backend', '6860b070-69bc-4ab4-ba11-7c3e0d34ca15'),
    ];
  }

  getTags() {
    return this.tags;
  }

  //getProjects() {
  //  return this.projects;
  //}





}
